const themeName = process.env.VUE_APP_THEME_NAME;
const theme = require(`@/assets/themes/${themeName}/themeConfig.json`);

export default {
  colorBackgroundButtonPrimary: theme.primary,
  colorBorderButtonPrimary: theme.primary,
  colorBackgroundButtonPrimaryHover: theme.primaryDark,
  colorBackgroundButtonPrimaryActive: theme.primaryDark,
  colorBorderDocTypeButtonHover: theme.primary,
  colorBorderDocTypeButtonActive: theme.primary,
  colorBorderLinkUnderline: theme.primary,
  colorBackgroundLinkHover: theme.primary,
  colorBackgroundLinkActive: theme.primary,
  colorContentButtonSecondaryText: '#000',
  colorBorderButtonSecondary: '#f3f5f7',
  colorBackgroundButtonSecondary: '#f3f5f7',
  colorBackgroundButtonSecondaryHover: '#e0e1e8',
  colorBackgroundButtonSecondaryActive: '#e0e1e8'
};
